import React, { useState } from "react";
import styled from "styled-components";
import { useQuery } from "@apollo/client";
import { Dropdown, Progress } from "semantic-ui-react";

import Review from "./Review";
import { Column } from "../../../genericComponents/Layout";

import YellowStar from "../../../../assets/images/front/YellowStar@2x.png";
import YellowActiveStar from "../../../../assets/images/front/YellowActiveStar@2x.png";
import { GET_DISCIPLINES } from "../../../../helpers/graphqlQueries";

const exams = [
  {
    key: "aselect",
    value: "",
    name: "Select Exam",
  },
  {
    key: "mcat",
    value: "mcat",
    name: "MCAT",
  },
  {
    key: "step_1",
    value: "step_1",
    name: "Step 1",
  },
  {
    key: "step_2",
    value: "step_2",
    name: "Step 2",
  },
  {
    key: "step_3",
    value: "step_3",
    name: "Step 3",
  },
];


export default function ReviewSection(props){
  const [activeStar, setActiveStar] = useState(null);
  const [disciplines, setDisciplines] = useState([]);
  const [filteredComments, setFilteredComments] = useState([]);
  const [activeFilters, setActiveFilters] = useState({
    usedInTests: "",
    specialties: "",
  });
  const [displayFilteredComments, setDisplayFilteredComments] = useState(false);

  const handleSetActiveFilter = (property, value) => {
    setActiveFilters((prevFilters) => ({
      ...prevFilters,
      [property]: value,
    }));
  };

  const handleFilter = () => {
    setFilteredComments(() => {
      let commentsCopy = props.comments.slice();
      Object.keys(activeFilters).forEach((key) => {
        if (key === "rating")
          commentsCopy = commentsCopy.filter(
            (comment) => comment[key] === activeFilters[key]
          );
        else if (activeFilters[key] !== "") {
          commentsCopy = commentsCopy.filter((comment) =>
            comment[key].includes(activeFilters[key])
          );
        }
      });
      return commentsCopy;
    });
    setDisplayFilteredComments(true);
  };

  const handleClearFilters = () => {
    setActiveStar(null);
    setActiveFilters({ usedInTests: "", specialties: "" });
    setFilteredComments([]);
    setDisplayFilteredComments(false);
  };

  useQuery(GET_DISCIPLINES, {
    onCompleted: (data) => {
      setDisciplines(data.medical_diciplines);
    },
  });

  const commentsToDisplay = displayFilteredComments
    ? filteredComments
    : props.comments;

    console.log(Object.values(props.stars))

  return (
    <SectionReview>
      <Filters>
        <Title>Reviews Filters</Title>
        <Subtitle>Filter by Stars</Subtitle>
        <StarsFilters>
          {Object.values(props.stars).slice(10,15).map((value, index) => (
            <StarsRow>
              {index + 1}
              <StarImage
                alt=''
                onClick={() => {
                  setActiveStar(index + 1);
                  handleSetActiveFilter("rating", index + 1);
                }}
                src={activeStar === index + 1 ? YellowActiveStar : YellowStar}
              />
              &nbsp;
              <BarContainer>
                <Progress
                  onClick={() => {
                    setActiveStar(index + 1);
                    handleSetActiveFilter("rating", index + 1);
                  }}
                  progress='value'
                  value={value}
                  size='small'
                  color='#111741'
                  total={props.reviewsCount}
                />
              </BarContainer>
              &nbsp;&nbsp;&nbsp;
              {Number(
                (value / props.reviewsCount ? value / props.reviewsCount : 0) *
                  100
              ).toFixed()}
              %
            </StarsRow>
          ))}
        </StarsFilters>
        <Subtitle>Filter by Exam</Subtitle>
        <StyledDropdown
          placeholder='Select Exam'
          fluid
          selection
          value={activeFilters["usedInTests"]}
          onChange={(_, { value }) =>
            handleSetActiveFilter("usedInTests", value)
          }
          options={exams.map((exam) => ({
            key: exam.key,
            value: exam.value,
            text: exam.name,
          }))}
        />
        <Subtitle>Filter by Discipline</Subtitle>
        <StyledDropdown
          placeholder='Select Location'
          fluid
          search
          selection
          value={activeFilters["specialties"]}
          onChange={(_, { value }) => {
            handleSetActiveFilter("specialties", value);
          }}
          options={disciplines.map((discipline) => ({
            value: discipline.dicipline_name,
            key: discipline.dicipline_name,
            text: discipline.dicipline_name,
          }))}
        />
        <FilterButtons>
          <ClearFilter onClick={handleClearFilters}>Clear Filters</ClearFilter>
          <Filter onClick={handleFilter}>Filter</Filter>
        </FilterButtons>
      </Filters>
      <ReviewsContainer>
        {commentsToDisplay.length ? (
          commentsToDisplay.map((rev) => (
            <Review
              markReviewAsHelpful={props.markReviewAsHelpful}
              handleReply={props.handleReply}
              {...rev}
            />
          ))
        ) : (
          <NoItemsContainer>
            {displayFilteredComments
              ? "No Results"
              : "Be the first to review this resource"}
            {!displayFilteredComments && (
              <Button
                style={{ marginTop: 30 }}
                onClick={() => props.handleCreateReview(props.id, props.title)}
              >
                Write a Review
              </Button>
            )}
          </NoItemsContainer>
        )}
        {!!commentsToDisplay.length && !displayFilteredComments && (
          <Button onClick={() => props.loadMore()}>Load More Reviews</Button>
        )}
      </ReviewsContainer>
    </SectionReview>
  );
};




const Button = styled.button`
  color: ${(props) => props.theme.color.darkBlue};
  font-weight: 500;
  padding: 9px 14px;
  line-height: 1.1;
  color: ${(props) => props.theme.color.darkBlue};
  background-color: ${(props) => props.theme.color.softPurple};
  border-radius: 2px;
  margin-top: -20px;
  outline: none;
  border: none;
  margin-bottom: 30px;
  margin-top: 30px;
  cursor: pointer;
`;

const NoItemsContainer = styled(Column)`
  width: 100%;
  align-items: center;
  margin-bottom: 30px;
  text-align: center;
  font-weight: 700;
`;

const SectionReview = styled.section`
  max-width: 1200px;
  display: flex;
  margin: auto;
  justify-content: space-between;
  @media (max-width: 720px) {
    flex-direction: column;
  }

`;

const Filters = styled.div`
  width: 365px;
  padding-right: 40px;
  color: ${(props) => props.theme.color.darkBlue};
  font-weight: 700;
  @media (max-width: 720px) {
    padding: 16px;
    width: 100%;
  }
`;
const ReviewsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex:1;
  padding: 16px;
`;
const Title = styled.h1`
  margin: 0 0 40px;
  font-weight: 700;
`;
const Subtitle = styled.h2`
  margin: 30px 0px;
`;
const StarsFilters = styled.div`
  display: flex;
  flex-direction: column;
`;
const StarsRow = styled.div`
  display: flex;
  flex-direction: row;
  padding: 3px 5px;
  align-items: flex-start;
  font-size: 18px;
`;
const BarContainer = styled.div`
  width: 150px;
`;
const StyledDropdown = styled(Dropdown)`
  padding: 10px 15px;
  height: 40px;
`;

const StarImage = styled.img`
  width:20px;
  height:20px;
  margin:-3px 10px ;
`;
const FilterButtons = styled.div`
  display: flex;
  flex-direction: row;
  margin-top:30px;
  padding: 20px 20px;
  justify-content: space-between;
  
`;
const Filter = styled(Button)`
  padding: 9px 45px;
  background: ${(props) => props.theme.color.darkBlue};
  color: ${(props) => props.theme.color.white};
`;
const ClearFilter = styled(Button)`
  background: ${(props) => props.theme.color.softPurple};
  color: ${(props) => props.theme.color.black};
`;